import React from 'react';
import { Box, Stepper, Step, StepLabel, Container } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const steps = ['Settings', 'Companies', 'Report'];

const CreateRequest = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    // Determine active step based on URL path
    const getActiveStep = () => {
        if (location.pathname.includes('companies')) return 1;
        if (location.pathname.includes('report')) return 2;
        return 0; // Default to Settings
    };

    // Handle step click navigation
    const handleStepClick = (index) => {
        switch(index) {
            case 0:
                navigate('/create-request');
                break;
            case 1:
                navigate('/create-request/companies');
                break;
            case 2:
                navigate('/create-request/report');
                break;
            default:
                // Optionally handle unexpected index values
                break;
        }
    };

    return (
            <Container sx={{ 
                width: '100%', 
                maxWidth: 'none !important', 
                paddingLeft: "0px !important", 
                paddingRight: "0px !important" 
            }}>
                <Box sx={{ 
                        width: '33%', 
                        mb: 4, 
                        marginLeft: '35%',
                        position: 'relative',
                        bottom: 45,
                        }}>
                    <Stepper activeStep={getActiveStep()}>
                        {steps.map((label, index) => (
                            <Step key={label}>
                                <StepLabel 
                                    // onClick={() => handleStepClick(index)}
                                    sx={{ cursor: 'pointer' }}
                                >{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
                
                {/* This renders Step1, Step2, or Step3 based on the route */}
                <Box>
                    <Outlet />
                </Box>
            </Container>
    );
};

export default CreateRequest;